var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("base-tutorial", { attrs: { steps: _vm.steps } }, [
    _c("div", [
      _c("h2", [
        _vm._v(
          "Olá! Vamos pensar quais são as responsabilidades da sua unidade?"
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [_vm._v("Identificação das responsabilidades")]),
      _c("div", [
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(
              " Responsabilidades são as atividades estratégicas desenvolvidas no âmbito de uma unidade. "
            ),
          ]
        ),
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(
              " Para esta etapa, é importante identificar se a responsabilidade descrita deve ser avaliada. Para isso, recomenda-se fazer a seguinte pergunta: "
            ),
          ]
        ),
        _c(
          "p",
          {
            staticClass:
              "mx-2 pa-2 text-center info--text font-weight-medium text-lg-h6",
          },
          [
            _vm._v(
              " Essa responsabilidade contribui para a realização da missão da unidade? "
            ),
          ]
        ),
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(
              " Se a resposta for sim, estamos diante de uma responsabilidade, que deve ser cadastrada. "
            ),
          ]
        ),
        _c(
          "p",
          {
            staticClass:
              "mx-2 pa-2 text-center info--text font-weight-medium text-lg-h6",
          },
          [_vm._v(" Então, quais são as responsabilidades da sua unidade? ")]
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [_vm._v("Impacto, Dificuldade e Competências Técnicas")]),
      _c("div", [
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(
              " Ao cadastrar uma responsabilidade, você deve indicar o nível de impacto e de dificuldade para a realização de cada uma, assim como as competências técnicas necessárias para sua execução. "
            ),
          ]
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [_vm._v("Níveis de Impacto")]),
      _c("div", [
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(
              " Para definir o nível de Impacto de uma responsabilidade considere que cada erro ou acerto na sua execução pode acarretar diferentes níveis de impacto para a instituição, conforme tabela abaixo: "
            ),
          ]
        ),
        _c("div", { staticClass: "d-flex justify-center" }, [
          _c(
            "p",
            { staticClass: "mx-2 pa-2 text-start font-weight-medium niveis" },
            [
              _c("span", { staticClass: "secondary--text" }, [
                _vm._v("Impacto 1: "),
              ]),
              _vm._v(" Fica limitado ao setor. "),
              _c("br"),
              _c("span", { staticClass: "primary--text" }, [
                _vm._v("Impacto 2: "),
              ]),
              _vm._v(" Afeta várias áreas, mas é administrável. "),
              _c("br"),
              _c("span", { staticClass: "success--text" }, [
                _vm._v("Impacto 3: "),
              ]),
              _vm._v(" Ultrapassa os portões da instituição. "),
            ]
          ),
        ]),
      ]),
    ]),
    _c("div", [
      _c("h2", [_vm._v("Níveis de Dificuldade")]),
      _c("div", [
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(
              " Para definir o nível de dificuldade de uma responsabilidade considere os diferentes níveis de dificuldade para a instituição, conforme tabela abaixo: "
            ),
          ]
        ),
        _c("div", { staticClass: "d-flex justify-center" }, [
          _c(
            "p",
            { staticClass: "mx-2 pa-2 text-start font-weight-medium niveis" },
            [
              _c("span", { staticClass: "secondary--text" }, [
                _vm._v("Dificuldade 1: "),
              ]),
              _vm._v(" Atividade está organizada ou estruturada. "),
              _c("br"),
              _c("span", { staticClass: "primary--text" }, [
                _vm._v("Dificuldade 2: "),
              ]),
              _vm._v(" Atividade pouco organizada ou estruturada. "),
              _c("br"),
              _c("span", { staticClass: "success--text" }, [
                _vm._v("Dificuldade 3: "),
              ]),
              _vm._v(
                " Atividade ainda sem organização ou estrutura definidas. "
              ),
            ]
          ),
        ]),
      ]),
    ]),
    _c("div", [
      _c("h2", [_vm._v("Competências Técnicas")]),
      _c("div", [
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(
              " Competências técnicas são os conhecimentos específicos ou ferramentas que o servidor precisa dominar para executar uma responsabilidade. No sistema você encontra uma lista geral, comum a várias unidades organizacionais, e você pode inserir outras próprias da sua unidade. Não há limite de competências técnicas necessárias por responsabilidade. "
            ),
          ]
        ),
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _c("b", [_vm._v("Exemplos de Competências Técnicas:")]),
            _vm._v(
              " legislação, aplicativos de informática, softwares de gestão, idiomas, etc. "
            ),
          ]
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [_vm._v("Importante!")]),
      _c("div", { staticClass: "mx-2 pa-2 justify-center" }, [
        _c("ul", [
          _c("li", [
            _c(
              "p",
              {
                staticClass:
                  "text-start font-weight-medium info--text text-lg-h6",
              },
              [
                _vm._v(
                  " Para escrever uma responsabilidade descreva “o que fazer” e não o “como fazer” a atividade. Utilize um "
                ),
                _c("span", { staticClass: "error--text" }, [
                  _vm._v("verbo no infinitivo"),
                ]),
                _vm._v(" + contextualização. "),
              ]
            ),
            _c(
              "p",
              { staticClass: "text-start font-weight-medium text-lg-h6" },
              [
                _vm._v(" Exemplo 1: "),
                _c("span", { staticClass: "error--text" }, [
                  _vm._v("Convocar"),
                ]),
                _c("span", { staticClass: "info--text" }, [
                  _vm._v(
                    " candidatos aprovados em concurso público para cargosefetivos."
                  ),
                ]),
              ]
            ),
            _c(
              "p",
              { staticClass: "text-start font-weight-medium text-lg-h6" },
              [
                _vm._v(" Exemplo 2: "),
                _c("span", { staticClass: "error--text" }, [
                  _vm._v("Realizar"),
                ]),
                _c("span", { staticClass: "info--text" }, [
                  _vm._v(
                    " a análise da documentação necessária à nomeação do candidato convocado."
                  ),
                ]),
              ]
            ),
          ]),
          _c("li", [
            _c(
              "p",
              {
                staticClass:
                  "text-start font-weight-medium info--text text-lg-h6",
              },
              [
                _vm._v(
                  " Cada servidor lotado na sua unidade deve executar no mínimo 1 (uma) das responsabilidades descritas, por isso, recomenda-se realizar o mapeamento técnico em conjunto com sua equipe. "
                ),
              ]
            ),
          ]),
          _c("li", [
            _c(
              "p",
              {
                staticClass:
                  "text-start font-weight-medium info--text text-lg-h6",
              },
              [
                _vm._v(
                  " Cadastre apenas as responsabilidades demandadas nos últimos 12 meses. "
                ),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }